import styles from './ControlPanel.module.scss'
import { ScryfallCard } from "@scryfall/api-types";
import Keyboard from "@/components/Keyboard/Keyboard";
import GuessBar from "@/components/Spellify/ControlPanel/GuessBar/GuessBar";

type Props =  {
    guessLimit: number,
    guessFunc: any,
    buttonState: {[index: string]: string},
    guessList: Array<'' | 'correct' | 'incorrect'>
    setIsGuessing: (isGuessing: boolean) => void
    isGuessing: boolean,
    gameState: 'guessing' | 'success' | 'failure'
    setModalOpen: (modalOpen: boolean) => void
    setIsViewingHistory: (isViewingHistory: boolean) => void
    isViewingHistory: boolean
}
const ControlPanel = ({
    guessLimit,
    guessFunc,
    buttonState,
    guessList,
    setIsGuessing,
    isGuessing,
    gameState,
    setModalOpen,
    setIsViewingHistory,
    isViewingHistory,
}: Props) => {

    const redList = Object.keys(buttonState).filter(key => buttonState[key] === 'red')
    const greenList = Object.keys(buttonState).filter(key => buttonState[key] === 'green')

    return (
        <div className={styles.controlpanel}>
            <div className={styles.buttoncontainer}>
                <GuessBar 
                    setModalOpen={setModalOpen} 
                    guessList={guessList} 
                    guessLimit={guessLimit} 
                    gameState={gameState} 
                    isGuessing={isGuessing} 
                    setIsGuessing={setIsGuessing}
                    setIsViewingHistory={setIsViewingHistory}
                    isViewingHistory={isViewingHistory}
                />
                <Keyboard onKeyPressed={guessFunc} secondaryMenu markedGreen={greenList} markedRed={redList} />
            </div>
        </div>
    )
}

export default ControlPanel